import { render, staticRenderFns } from "./PayrollImport.vue?vue&type=template&id=748ef3fb&scoped=true&"
import script from "./PayrollImport.vue?vue&type=script&lang=ts&"
export * from "./PayrollImport.vue?vue&type=script&lang=ts&"
import style0 from "./PayrollImport.vue?vue&type=style&index=0&id=748ef3fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748ef3fb",
  null
  
)

export default component.exports